import { UsersService } from '../../services/users.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { AppHelper } from '../../helpers/app.helper';
import { TaxonomyService } from '../../services/taxonomy.service';


@Component({
  selector: 'app-initializer',
  templateUrl: './initializer.component.html',
  styleUrls: ['./initializer.component.css']
})
export class InitializerComponent implements OnInit, OnDestroy {
  private loadingSubject = new BehaviorSubject<boolean>(false);

  isLoading$ = this.loadingSubject.asObservable();

  error: string;

  constructor(
    private usersService: UsersService,
    private taxonomyService: TaxonomyService,
    private appHelper: AppHelper,
    private router: Router) { }

  ngOnInit(): void {
    this.initialize();
  }

  ngOnDestroy(): void {
    this.loadingSubject.complete();
  }

  async initialize(): Promise<void> {
    try {
      this.error = null;
      this.loadingSubject.next(true);

      if (!this.taxonomyService.isInitialized) {
        await this.taxonomyService.initializeAsync();
      }

      if (this.usersService.currentUser) {
        this.router.navigate(['/taxonomies']);
      } else {
        this.router.navigate(['/welcome']);
      }
    } catch (error) {
      this.error = this.appHelper.getErrorMessage(error);
    } finally {
      this.loadingSubject.next(false);
    }
  }
}
